import React from "react";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { Route } from "react-router";
import { AppLayoutView } from "./../layout/app-layout";
import AdminRoute from "./admin-route";

const AppLayout = withRouter(AppLayoutView);

export const AppLayoutRoute = ({ component: Component, ...rest }) => {
    const adminRoute = rest.adminRoute || rest.canUserAccessTemplates;
    return (
        <Route {...rest} render={matchProps => (
            <AppLayout history = {matchProps.history}>
                {
                    adminRoute
                        ? <AdminRoute {...matchProps} component={Component} />
                        : <Component {...matchProps} />

                }
            </AppLayout>
        )} />
    );
};

AppLayoutRoute.propTypes = {
    component: PropTypes.func
};